<script setup lang="ts">
import dayjs from "dayjs";

const { $api } = useNuxtApp()

const loading = ref(false)

const chartData = ref({
  prices: [],
  labels: []
})

const pricesDate = ref(dayjs().format('YYYY-MM-DD'))

const fetchPrices = async (limit?: number) => {
  loading.value = true;

  try {
    const response = await $api<{ data: any[] }>("api/kwhprices/comparison", {
      query: {
        limit: 1,
      },
    });

    const values = Object.values(response.data)[0]

    pricesDate.value = dayjs(values[0]?.date).format('YYYY-MM-DD');
    chartData.value.prices = values.map(i => i.price);
    chartData.value.labels = values.map(i => i.companyName);

  } catch (error) {
    console.error("Error fetching news:", error);
  } finally {
    loading.value = false;
  }
};

onMounted(fetchPrices)
</script>

<template>
  <section class="bg-dark-blue pt-60 pb-140">
    <div class="container">
      <div class="lg:text-center mb-45">
        <h1 class="text-cyan">Vi tål att jämföras</h1>
        <p class="text-20 mb-16 leading-normal text-gray-light">
          Hos oss betalar du för el. Inget annat.
          Under jämförelsemånaden var vårt elpris 7,7% procent lägre än genomsnittet för svenska elbolag*.
          Det innebär att du får ett tryggt fossilfritt elavtal till ett av marknadens mest konkurrenskraftiga pris.
        </p>
        <p class="text-20 mb-80 text-gray-light"><i>Staplarna nedan visar öre per kWh ink. moms.</i></p>
        <Chart v-if="chartData.prices.length" :chartData="chartData" class="max-w-[60rem] mx-auto w-full" />
        <p class="text-20 mb-16 mt-30 text-cyan">
          Tabellen uppdaterades {{ pricesDate }}
        </p>
      </div>
      <p class="lg:text-center text-gray-light text-20 leading-normal max-w-[60rem] mx-auto">
        *Priserna är hämtade ur rapporten från <a class="text-cyan" target="_blank" href="https://elpriskollen.se/">Elpriskollen.se</a>, en statlig jämförelsesajt
        från <a class="text-cyan" target="_blank" href="https://ei.se/">Energimarknadsinspektionen</a>. Rapporten avser december 2024, Elområde 3, 20 000 kWh.
        Priserna är totalt örespris per kWh, dvs där ALLA kostnader för elhandelsavtalet är inkluderat,
        såsom månadsavgifter, driftskostnader och moms. Här kan du läsa mer om de <nuxt-link class="text-cyan" to="/elavtal">elavtal vi erbjuder</nuxt-link>.
      </p>
    </div>
  </section>
</template>

<style scoped>

</style>
